import { isAWSPresignedUrl } from "types/dataset";
// We have subtly conflicting implementations of how the backend can return presigned urls.
// Armen's implementation of BlobStore returns strings that will be a url for most cloud providers, but an encoded json object for AWS.
// Cloudops returns a DatasetUpload which has the same characteristics as Armen, but has an additional data_url that has to be checked to determine if the presigned url is meant for Azure or GCP.
// In the future, we can maybe rectify these differences, but for now this will follow Armen's example and if needed, constructing individual requests can use the utility functions instead.
export function sendPresignedRequest(data, url) {
    let upload_url;
    try {
        upload_url = JSON.parse(url);
    }
    catch {
        upload_url = url;
    }
    // MB: I don't really love this, but because FormData only supports this and
    // AWS only supports FormData. As far as I know, it would be an invalid
    // request.
    if (isAWSPresignedUrl(upload_url) && (typeof data === "string" || data instanceof Blob)) {
        return sendAWSPresignedRequest(data, upload_url);
    }
    const parsed_url = URL.parse(upload_url);
    if (parsed_url?.hostname.includes("azure") || parsed_url?.hostname.includes("windows")) {
        return sendAzurePresignedRequest(data, upload_url);
    }
    if (parsed_url?.hostname.includes("google")) {
        return sendGCPPresignedRequest(data, upload_url);
    }
    return Promise.reject("Invalid presigned url");
}
export function sendAWSPresignedRequest(data, url_data) {
    const { url, fields } = url_data;
    const formData = new FormData();
    Object.entries(fields).forEach(([key, value]) => {
        formData.append(key, value);
    });
    formData.append("file", data);
    return fetch(url, {
        method: "POST",
        mode: "no-cors",
        body: formData
    });
}
export function sendAzurePresignedRequest(data, url) {
    return fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/octet-stream",
            "x-ms-blob-type": "BlockBlob"
        },
        body: data
    });
}
export function sendGCPPresignedRequest(data, url) {
    return fetch(url, {
        method: "PUT",
        headers: {
            "Content-Type": "application/octet-stream"
        },
        body: data
    });
}
